import React, { useState } from "react";
import "../../assetss/css/App.css";
import { Container, Alert, AlertTitle } from "@mui/material";
import Box from "@mui/material/Box";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import dayjs from "dayjs";
import "dayjs/locale/en-gb";
import { ModeloGetUrl } from "../ModeloCrud";
import { Typography } from "@mui/material";
import { CSVLink } from "react-csv";
import * as moment from "moment";
import LoadingButton from "@mui/lab/LoadingButton";
import SearchIcon from "@mui/icons-material/Search";
import ApiService from "../../apis/ApiService";
import ModalInformation from "../modals/ModalInformation";
import { Modal } from "react-bootstrap";

export default function ReporteTurnosPortal() {
  let [reportData, setReportData] = useState(null);
  const [loading, setLoading] = useState(false);
  const now = new Date().toISOString().slice(0, 10);
  const [fechaDesde, setFechaDesde] = useState(dayjs(now));
  const [fechaHasta, setFechaHasta] = useState(dayjs(now));
  const [fileName, setFileName] = useState(null);
  const [modalMessage, setModalMessage] = useState("");
  const [modalSuccessOpen, setModalSuccessOpen] = useState(false);
  const [modalErrorOpen, setModalErrorOpen] = useState(false);

  const hideSuccessModal = () => {
    setModalMessage(null);
    setModalSuccessOpen(false);
  };

  const hideErrorModal = () => {
    setModalMessage(null);
    setModalErrorOpen(false);
  };

  const handleDownload = async () => {
    const desde = fechaDesde.toISOString().slice(0, 10);
    const hasta = fechaHasta.toISOString().slice(0, 10);

    try {
      setLoading(true);
      await ApiService.GetTurnosExcel(desde, hasta);
      setModalMessage(
        "Excel de turnos generado y descargado.Busque en la carpeta de descargas."
      );
      setModalSuccessOpen(true);
    } catch (error) {
      setModalMessage("No se pudo generar el Excel de turnos " + error.message);
      setModalErrorOpen(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container maxWidth="xl">
      <Box
        sx={{
          marginBottom: 4,
          marginLeft: 1,
        }}
      >
        <Typography variant="h6">
          Turnos asignados en el portal de pacientes
        </Typography>
      </Box>
      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", md: "row" },
          justifyContent: "start",
          marginTop: 1,
          marginBottom: 5,
          marginLeft: 1,
        }}
      >
        <LocalizationProvider
          dateAdapter={AdapterDayjs}
          adapterLocale={"en-gb"}
        >
          <DatePicker
            label="Fecha Desde"
            value={fechaDesde}
            slotProps={{ textField: { size: "small" } }}
            onChange={(newValue) => setFechaDesde(newValue)}
            sx={{
              height: "1rem",
              width: "17.8rem",
            }}
          />
        </LocalizationProvider>
        <LocalizationProvider
          dateAdapter={AdapterDayjs}
          adapterLocale={"en-gb"}
        >
          <DatePicker
            label="Fecha Hasta"
            value={fechaHasta}
            slotProps={{ textField: { size: "small" } }}
            onChange={(newValue) => setFechaHasta(newValue)}
            sx={{
              height: "1rem",
              width: "17.8rem",
              marginLeft: { xs: 0, md: 2 },
              marginTop: { xs: 6, md: 0 },
            }}
          />
        </LocalizationProvider>
        <LoadingButton
          size="medium"
          onClick={handleDownload}
          loading={loading}
          loadingPosition="start"
          endIcon={<SearchIcon />}
          sx={{
            backgroundColor: "primary.main",
            ":hover": {
              bgcolor: "#475569", // theme.palette.primary.main
              color: "white",
            },
            width: 80,
            marginTop: { xs: 3, md: 0.5 },
            marginLeft: { xs: 0, md: 1 },
          }}
          variant="contained"
        >
          <span></span>
        </LoadingButton>
      </Box>
      {reportData !== null && reportData.length > 0 && (
        <Box sx={{ display: "flex" }}>
          <Typography variant="h6" sx={{ marginLeft: 2 }}>
            Se encontraron {reportData.length} resultados.
          </Typography>
          <CSVLink data={reportData} separator={";"} filename={fileName}>
            <Box sx={{ display: "flex", marginLeft: 4 }}>
              <i class="fa-solid fa-file-csv fa-xl ml-1 mt-3 mr-2 text-emerald-600"></i>
              <Typography variant="h6">Descargar </Typography>
            </Box>
          </CSVLink>
        </Box>
      )}
      {reportData !== null && reportData.length === 0 && (
        <Typography variant="h6" sx={{ marginLeft: 2 }}>
          No se encontraron resultados.
        </Typography>
      )}
      <ModalInformation
        showModal={modalErrorOpen && modalMessage !== null}
        hideModal={hideErrorModal}
        message={modalMessage}
        tipo="error"
      />
      <ModalInformation
        showModal={modalSuccessOpen && modalMessage !== null}
        hideModal={hideSuccessModal}
        message={modalMessage}
        tipo="success"
      />
    </Container>
  );
}
